// bigjson — bigint-safe JSON codec used by the apiClient transformers.
//
// Why this exists (CLAUDE.md rule 6 — money is bigint end-to-end):
//   The backend serialises amount_minor as a JSON integer (Go int64). For a
//   single payout that fits inside Number.MAX_SAFE_INTEGER (2^53 ≈ ₹90T), so
//   `JSON.parse` does not lose precision. But aggregates — batch totals,
//   `/v1/stats` settled-by-currency, lifetime tallies — can exceed 2^53 once
//   the business runs long enough. At that point JSON.parse silently rounds
//   to the nearest f64, and `BigInt(parsedNumber)` cannot recover the lost
//   low bits — it just wraps the already-corrupt value.
//
//   json-bigint with `useNativeBigInt:true, alwaysParseAsBig:false` upgrades
//   ONLY integers that exceed the safe-integer range to native bigint;
//   smaller ints stay as `number` so ids / row counts / status codes don't
//   suddenly become bigint everywhere in the codebase.
//
//   On the request side, the standard JSON.stringify throws when it
//   encounters a bigint. json-bigint serialises bigint as a plain JSON
//   integer (no "n" suffix), so we can keep money as bigint all the way to
//   the wire without a `Number(paise)` truncation step.
import JSONbig from "json-bigint";

const codec = JSONbig({ useNativeBigInt: true, alwaysParseAsBig: false });

export function parseJsonBig(s: string): unknown {
  return codec.parse(s);
}

export function stringifyJsonBig(v: unknown): string {
  return codec.stringify(v);
}
